/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class Providers
 */
import RestService from '@/modules/backend/RestService';
import { Provider } from '@/modules/backend/Entities/Provider';
import { plainToClass } from 'class-transformer';
import { CreateProviderData } from '@/modules/backend/Dto/CreateProviderData';
import { EditProviderData } from '@/modules/backend/Dto/EditProviderData';

export class Providers {
  private readonly rest: RestService;

  constructor(rest: RestService) {
    this.rest = rest;
  }

  public async fetch(): Promise<Provider[]> {
    try {
      const items = await this.rest.get<unknown[]>('/api/v1/providers');
      return plainToClass(Provider, items);
    } catch {
      return [];
    }
  }

  public async create(data: CreateProviderData): Promise<Provider> {
    const item = await this.rest.post<unknown>('/api/v1/provider', data);
    return plainToClass(Provider, item);
  }

  public async edit(data: EditProviderData): Promise<Provider> {
    const item = await this.rest.put<unknown>('/api/v1/provider', data);
    return plainToClass(Provider, item);
  }

  public async remove(providerId: number): Promise<void> {
    await this.rest.delete(`/api/v1/provider/${providerId}`);
  }
}
